export const fontStyleName = (family: { name: string }, font: { name: null | string; weight: string }) =>
    font.name || `${family.name} ${font.weight}`;

export const fontFullName = (family: { name: string }, font: { name: null | string; weight: string }) => {
    const style = fontStyleName(family, font);

    return style.toLowerCase().startsWith(family.name.toLowerCase()) ? style : `${family.name} ${style}`;
};
